import React, { useEffect, useState } from "react";
import { Box, Card, CardMedia, Typography } from "@mui/material";
import axios from "axios";

const ProductCarousel = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Fetch categories from backend
    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://reviewhub-lc.onrender.com/api/categories"); 
        setCategories(res.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Repeat for seamless scroll
  const repeatedCategories = [...categories, ...categories];

  return (
    <Box
      sx={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "100%",
        py: 2,
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          animation: "scrollLeft 40s linear infinite",
        }}
      >
        {repeatedCategories.map((cat, idx) => (
          <Card
            key={idx}
            sx={{
              width: 140,
              mx: 1,
              display: "inline-block",
              textAlign: "center",
              backgroundColor: "#fff",
              borderRadius: 2,
              boxShadow: 3,
              flexShrink: 0,
            }}
          >
            <CardMedia
              component="img"
              image={`https://reviewhub-lc.onrender.com/uploads/${cat.image}`} 
              alt={cat.categoryName}
              sx={{ height: 100, objectFit: "contain", p: 1 }}
            />
            <Typography variant="body2" sx={{ p: 1, fontSize: 12 }}>
              {cat.categoryName}
            </Typography>
          </Card>
        ))}
      </Box>

      <style>
        {`
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </Box>
  );
};

export default ProductCarousel;
